module.exports = __webpack_public_path__ + "static/pc_service_blockchain-2858451ad3ed752e2a71843dd53b369f.jpg";